__turbopack_context__.v({
  "input-text": "_-module__nTmZvq__input-text",
  "input-text--disabled": "_-module__nTmZvq__input-text--disabled",
  "input-text--hover": "_-module__nTmZvq__input-text--hover",
  "input-text--lg": "_-module__nTmZvq__input-text--lg",
  "input-text--md": "_-module__nTmZvq__input-text--md",
  "input-text--mono": "_-module__nTmZvq__input-text--mono",
  "input-text--negative": "_-module__nTmZvq__input-text--negative",
  "input-text--segment-center": "_-module__nTmZvq__input-text--segment-center",
  "input-text--segment-left": "_-module__nTmZvq__input-text--segment-left",
  "input-text--segment-none": "_-module__nTmZvq__input-text--segment-none",
  "input-text--segment-right": "_-module__nTmZvq__input-text--segment-right",
  "input-text--sm": "_-module__nTmZvq__input-text--sm",
  "input-text--success": "_-module__nTmZvq__input-text--success",
  "input-text__main-icon": "_-module__nTmZvq__input-text__main-icon",
  "input-text__modifiers": "_-module__nTmZvq__input-text__modifiers",
  "input-text__secondary-icon": "_-module__nTmZvq__input-text__secondary-icon",
  "theme-dark": "_-module__nTmZvq__theme-dark",
});
